"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M11 14h2v-3h3l-4-4-4 4h3z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M3 3v18h18V3zm16 11h-4.18c-.41 1.16-1.51 2-2.82 2s-2.4-.84-2.82-2H5V5h14z"
}, "1")], 'OutboxSharp');